export default __webpack_public_path__ + "static/media/how-it-works-3.f3081d6f.png";